import styled from 'styled-components';
import { Modal } from '../../../../../../lib/components/Modal/Modal';

export const StyledChangeGeofenceModal = styled(Modal)`
  .change-geofence-modal__map {
    height: 80vh;
    width: 100%;
  }
`;
